import jQuery from 'jquery';

jQuery(function ($) {
    'use strict';

    const $header = $('.site-header');
    const $opener = $header.find('.site-header__opener');
    const $searchForm = $header.find('.search-form');
    const desktopMql = window.matchMedia('(min-width: 1025px)');
    const $menuItems = $header.find('.has-children');
    const $homeHero = $('.hero--homepage');

    const debounce = (fn, ms = 100) => {
        let timeoutId;

        return function(...args) {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => fn.apply(this, args), ms);
        };
    };

    function overflowsScreen($el) {
        if ($el.closest('.site-header__navigation--simple').length > 0) {
            const $subnav = $el.find('.subnav').first();
            $subnav.css({'visibility': 'hidden', 'display': 'block'});
            let w = $subnav.outerWidth();
            let l = $subnav.offset().left;
            $subnav.css({'visibility': '', 'display': ''});
            return (l + w) > window.innerWidth;
        } else {
            return false;
        }
    }

    function initNavHovers () {
        if (desktopMql.matches) {
            // Delay closing of nav items and toggle aria-expanded on hover
            $menuItems.each(function () {
                const $item = $(this);
                let timer;

                $item
                    .on('mouseover', function () {
                        $item.addClass(overflowsScreen($item) ? 'open-left' : 'open');
                        $item.find('a, button').attr('aria-expanded', 'true');
                        clearTimeout(timer);
                    })
                    .on('mouseout', function () {
                        timer = setTimeout(function () {
                            $item.removeClass('open open-left');
                            $item.find('a, button').attr('aria-expanded', 'false');
                        }, 10);
                    });
            });
        } else {
            // If on mobile, remove hover events
            $menuItems.off('mouseover mouseout');
        }
    }

    initNavHovers();

    // Toggle mobile navigation
    $opener.click(function () {
        $(this).closest('.site-header').toggleClass('open');
        $(this).attr('aria-expanded', function (i, attr) {
            return attr === 'true' ? 'false' : 'true';
        });
    });

    // Hide mobile navigation if screen size changes across desktop breakpoint
    desktopMql.addEventListener('change', function () {
        $header.removeClass('open');
        initNavHovers();
    });

    // Toggle/Submit search form
    $searchForm.on('submit', function (ev) {
        if (!$(this).closest('.site-header').hasClass('open') && !$(this).hasClass('open')) {
            ev.preventDefault();
            $(this).addClass('open');
            $(this).find('input').focus();
            $(this).find('button').attr('aria-label', 'Submit search query');
        }
    });

    // Toggle subnav via button for keyboard users and for mobile nav
    $menuItems.find('button').on('click',  function(e){
        e.preventDefault();

        let $btn = $(this);
        let $listItem = $btn.closest('.has-children');
        if ($listItem.hasClass('open')) {
            $listItem.removeClass('open');
            $btn.attr('aria-expanded', 'false');
            $listItem.children('a').attr('aria-expanded', 'false');
        } else {
            $listItem.addClass('open');
            $btn.attr('aria-expanded', 'true');
            $listItem.children('a').attr('aria-expanded', 'true');
        }
    });

    // Remove bottom padding if tall hero is present with no breadcrumb
    if ($homeHero.length) {
        $homeHero.css('margin-top', '-' + $header.outerHeight() + 'px');

        $(window).on('resize', debounce(() => {
            $homeHero.css('margin-top', '-' + $header.outerHeight() + 'px');
        }));
    }

    const $hero = $('main > .hero:first-child');
    const $bgForm = $('main > .form-card--background:first-child');
    const $breadcrumb = $('.breadcrumb');

    if ($breadcrumb.length) {
        // Remove bottom margin from breadcrumb if hero is first child of main
        if ($hero.length) {
            $breadcrumb.css('margin-bottom', 0);
        }

        // Remove bottom margin from breadcrumb if form card with BG is first child of main
        if ($bgForm.length) {
            $breadcrumb.css('margin-bottom', 0);
        }
    }
});
